import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

import I18nText from "../components/I18nText";
import { ArrowIcon } from "../components/ArrowIcon";
import { track } from "../lib/analytics";

export default function Landing() {
    const { t } = useTranslation();

    useEffect(() => {
        track("landing_view", {});
        document.title = t("landing.title");
    }, [t]);

    const trackDoor = (target) => () => track("door_click", { target });

    return (
        <>
            <section className="lg-section hero" data-testid="landing-hero">
                <div>
                    <div className="hero-tagline mono">{t("landing.tagline")}</div>
                    <h1>
                        <I18nText i18nKey="landing.h1" />
                    </h1>
                    <p className="hero-sub">{t("landing.sub")}</p>

                    <div className="doors">
                        <Link
                            to="/employers"
                            className="door"
                            data-testid="door-employer"
                            onClick={trackDoor("employer")}
                        >
                            <div className="door-num mono">{t("landing.doorEmployerNum")}</div>
                            <div className="door-label">{t("landing.doorEmployerLabel")}</div>
                            <div className="door-sub">{t("landing.doorEmployerSub")}</div>
                            <div className="door-arrow"><ArrowIcon direction="up-right" /></div>
                        </Link>
                        <Link
                            to="/employees"
                            className="door"
                            data-testid="door-employee"
                            onClick={trackDoor("employee")}
                        >
                            <div className="door-num mono">{t("landing.doorEmployeeNum")}</div>
                            <div className="door-label">{t("landing.doorEmployeeLabel")}</div>
                            <div className="door-sub">{t("landing.doorEmployeeSub")}</div>
                            <div className="door-arrow"><ArrowIcon direction="up-right" /></div>
                        </Link>
                    </div>

                    <div className="cred-strip" data-testid="cred-strip">
                        <div className="cred-item">
                            <div className="cred-num">1851</div>
                            <div className="cred-label mono">{t("landing.cred.yearLabel")}</div>
                        </div>
                        <div className="cred-item">
                            <div className="cred-num">$895B</div>
                            <div className="cred-label mono">{t("landing.cred.inForceLabel")}</div>
                        </div>
                        <div className="cred-item">
                            <div className="cred-num">156+ yrs</div>
                            <div className="cred-label mono">{t("landing.cred.dividendsLabel")}</div>
                        </div>
                        <div className="cred-item">
                            <div className="cred-num">A++</div>
                            <div className="cred-label mono">{t("landing.cred.ratingLabel")}</div>
                        </div>
                    </div>
                    <p className="cred-tagline" data-testid="cred-tagline">
                        {t("landing.cred.tagline")}
                    </p>
                </div>
            </section>
        </>
    );
}
